import { render, staticRenderFns } from "./TabCustomerList.vue?vue&type=template&id=5dd829ce&scoped=true"
import script from "./TabCustomerList.vue?vue&type=script&lang=js"
export * from "./TabCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd829ce",
  null
  
)

export default component.exports